import React from 'react';
import style from './index.scss';
import { BrushLineChart } from '../../../components/ns/BrushChart';

const ThroughPut = ({ data, meta }) => {
  if (data && meta) {
    return (
      <div className={style.dualCharts}>
        <div style={{ flexDirection: 'column' }}>
          <div className={style.dualChartsTitle}>Throughput</div>
          <div style={{ width: '100%' }}>
            <BrushLineChart
              text={'Throughput'}
              data={data}
              dataKey="date"
              chartMeta={meta}
            />
          </div>
          <div className={style.dualChartsSubTitleCentered}>
            <p>Performance Chart</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ThroughPut;
